import React from "react";
import { markdown } from "markdown";

export default ({ location, educationName, mainSubjects, dates }) => (
  <div className="panel panel-default">
    <div className="panel-heading" id="headingOne" role="tab">
      <h4 className="panel-title">
        <a
          aria-controls="collapseOne"
          aria-expanded="true"
          data-parent="#accordion"
          data-toggle="collapse"
          href="#collapseOne"
        >
          {educationName} - {location}
        </a>
      </h4>
    </div>
    <div
      aria-labelledby="headingOne"
      className="panel-collapse collapse in"
      id="collapseOne"
      role="tabpanel"
    >
      <div className="panel-body">
        <div className="row">
          <div className="col-md-6">
            <p>{dates}</p>
          </div>
          <div className="col-md-6">
            <ul>
              {mainSubjects.map(subject => <p key={subject}>{subject}</p>)}
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/education.js